/**
 * @description模块控制函数
 * @param status 1 待提交 2 待审核 3 审核未通过 8 审核通过 4 已立案 5 审理中 6 已结案 7 已结案
 * @param sfct 是否重新提交 1 可编辑  2 不可编辑
 */

export default function componentController(status, sfct = '') {
  let key = String(status)
  if(key === '101' || key === '102'){
    key = '1'
  }
  if (key === '3') {
    key += Number(sfct) === 1 ? '_1' : '_2'
  }
  let obj = {
    '1': {
      disabled: false,
      // 立案信息 && 结案信息
      base: {
        bseQfkjzrq: {required: false, disabled: false},
      },
    },
    '2': {
      disabled: true,
      base: {
        bseQfkjzrq: {required: false, disabled: false},
      },
    },
    '3_1': {
      disabled: false,
      // 立案信息 && 结案信息
      base: {
        bseQfkjzrq: {required: true, disabled: false},
      },
    },
    '3_2': {
      disabled: true,
      // 立案信息 && 结案信息
      base: {
        bseQfkjzrq: {required: true, disabled: true},
      },
    },
    '8': {
      disabled: true,
      // 立案信息 && 结案信息
      base: {
        disabled: true,
        bseQfkjzrq: {required: true, disabled: true},
      },
    },
    '4': {
      disabled: true,
      // 立案信息 && 结案信息
      base: {
        bseQfkjzrq: {required: true, disabled: true},
      },
    },
    '5': {
      disabled: true,
      // 立案信息 && 结案信息
      base: {
        bseQfkjzrq: {required: true, disabled: true},
      },
    },
    '6': {
      disabled: true,
      // 立案信息 && 结案信息
      base: {
        bseQfkjzrq: {required: true, disabled: true},
      },
    },
    '7': {
      disabled: true,
      // 立案信息 && 结案信息
      base: {
        bseQfkjzrq: {required: true, disabled: true},
      },
    },
  }
  return obj[key]
}
